<!-- eslint-disable max-len -->
<template>
  <aha-modal
    @hide="$emit('hide')"
    :title="$i18nPresenter.t('Take over')"
    class="take-over-modal"
  >
    <p class="mb-2">
      <span v-if="presenting" v-html="$i18nPresenter.t('atMomentPrezIsBeingPresented')">
      </span>

      <span v-else v-html="$i18nPresenter.t('atMomentPrezIsBeingEdited')">
      </span>
    </p>
    <div class="flex items-center p-2 mb-3 bg-secondary-10">
      <aha-avatar
        class="mr-2 text-lg"
        :name="presentation.TakenOverByUser.firstName"
        :image="presentation.TakenOverByUser.avatar"
        :id="presentation.TakenOverByUser.id"
        :width="36"
        :height="36"
      />
      <div class="flex flex-col">
        <span class="font-bold">
          <strong>{{ presentation.TakenOverByUser.firstName }}</strong>
        </span>
        <p>{{ presentation.TakenOverByUser.email }}</p>
      </div>
    </div>
    <p>
      {{ $i18nPresenter.t('Once you take over, they will become a viewer and only you will be able to edit and present this presentation.') }}
    </p>
    <template #action>
      <aha-button
        variant="danger"
        @click="$emit('takeOver')"
        :submitting="submitting"
        :disabled="submitting"
      >
        {{ $i18nPresenter.t('Take over') }}
      </aha-button>
      <aha-link
        has-margin-left
        @click="$emit('hide')"
      >
        <span class="font-bold">{{ $i18nPresenter.t('Cancel') }}</span>
      </aha-link>
    </template>
  </aha-modal>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    presenting: {
      type: Boolean,
      default: false,
    },
    submitting: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
    }),
  },
}
</script>

<style lang="scss" scoped>

</style>
